import script from "./ArticleEditorMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleEditorMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleEditorMolecule.css?vue&type=style&index=0&id=2833e5e3&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2833e5e3"]])

export default __exports__